import { SalesFetchProps } from '../../types/api'
import { TIME } from '../../utils/misc'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../constants/query-keys'
import { fetchSalesHourly } from '../../queries/sales/hourly'
import { useAnalytics } from 'utils/analytics'

export function useSalesHourly({
    env,
    accessToken,
    location,
    filters,
    dynamicSubPath,
}: SalesFetchProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.SALES_HOURLY, location],
        () =>
            fetchSalesHourly({
                env,
                accessToken,
                location,
                filters,
                dynamicSubPath,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
